import React, {useEffect, useState} from 'react';
import {Card} from "primereact/card";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Paginator} from "primereact/paginator";
import useApi from "../../hooks/useApi";
import {webInfo} from "../../utils/webInfo";
import moment from "moment";
import {Dropdown} from "primereact/dropdown";
import ErrorPresentor from "../../ErrorPresentor/ErrorPresentor";
import TableSkeleton from "../../Loader/Loader";
import {InputSwitch} from "primereact/inputswitch";
import {Dialog} from "primereact/dialog";
import {catchError} from "../../utils/helper";
import useDelete from "../../hooks/useDelete";
import {Skeleton} from "primereact/skeleton";
import usePost from "../../hooks/usePost";
import {Link, useNavigate} from "react-router-dom";
import EmptyData from "../../components/EmptyData";


const Newsroom = () => {
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const {get, loading, error} = useApi<any>();
    const url = `${webInfo.baseUrl}/api/admin/news-events?page=${page}&per_page=${perPage}`
    const categoryUrl = `${webInfo.baseUrl}/api/admin/news-events-categories?page=1&per_page=200`
    const [blogs,setBlogs] = useState([])
    const [blogsCategory,setBlogsCategory] = useState([])
    const [visibleConfirmation, setVisibleConfirmation] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const {remove,loading:rloading} = useDelete()
    const {post,loading:ploading} = usePost()
    const [update,setUpdate] = useState<boolean>(false)

    const [selectedCategory, setSelectedCategory] = useState({name:"Select Category",code:null})
    const navigate = useNavigate();
    const onPageChange = (event: any) => {
        setPage(event.page + 1);
    }

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const res: any = await get(url);
                setBlogs(res.data.data);
                setTotal(res.data.total);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchNews();
        // eslint-disable-next-line
    }, [page, perPage,update]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await get(categoryUrl);
                const options = res.data.map((item:any)=>{
                    return {
                        name: item.name,
                        code: item.id,
                    }
                })
                setBlogsCategory(options);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, []);

    // Render blog image
    const imageTemplate = (rowData:any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.image}`}
            alt={'blogs'}
            style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "6px",
            }}
        />
    );

    const publishStatus = (rowData:any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/news-events/${rowData.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.is_active)===1 ? 0 : 1,
            }
            try {
                const res:any = await post(statusUpdateUrl,true,payload,true)
                if (res.success){
                    setUpdate(!update);
                }
            }catch (e) {
                catchError(e)
            }
        }

        if (ploading){
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.is_active) === 1} onChange={()=>updateStatus(rowData)}  />
        </div>
    }

    const categoryTemplate = (rowData:any) => {
        const category:any = blogsCategory?.find((item:any)=> Number(item.code) === Number(rowData.category_id));
        return <span>{category?.name}</span>
    }

    const deleteNews = async () => {
        const deleteUrl = `${webInfo.baseUrl}/api/admin/news-events/${selectedId}`;
        try {
            const res:any = await remove(deleteUrl)
            if (res.success){
                setUpdate(!update);
                setVisibleConfirmation(false)
            }
        }catch (e) {
            catchError(e)
        }
    }

    // Action buttons
    const actionTemplate = (rowData:any) => {

        return <div className="flex gap-2 justify-content-center">
            <Button
                icon="pi pi-pencil"
                title="Edit"
                className="p-button-sm"
                onClick={() => navigate(`/newsroom/${rowData.id}`)}
            />
            <Button severity={'danger'} disabled={rloading} title={'Delete'} icon={'pi pi-trash'} onClick={()=>{
                setVisibleConfirmation(true)
                setSelectedId(rowData.id)
            }}/>
        </div>
    };

    const titleAuthor = (rowData:any) => {
        return <div>
            <small>{moment(rowData.created_at).format("LL")}</small>
            <h5 className="m-0">
                <Link className="text-gray-900 underline" to={`/newsroom/${rowData.id}`}>{rowData.title}</Link>
            </h5>
            <i>by {rowData.author}</i>
        </div>
    }

    if (error) {
        return <ErrorPresentor error={error}/>
    }

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Remove news confirmation</span>
        </div>
    );
    const footerContent = (
        <div className="flex justify-content-end align-items-center">
            <Button label="cancel" icon="pi pi-times" onClick={() => setVisibleConfirmation(false)} autoFocus />
            <Button label="Delete" severity={'danger'} className="ml-2" icon="pi pi-delete" onClick={deleteNews} autoFocus />
        </div>
    );

    const dataTable = <div>
        <Dialog visible={visibleConfirmation} modal header={headerElement} footer={footerContent} style={{ width: '30rem' }} onHide={() => {if (!visibleConfirmation) return; setVisibleConfirmation(false); }}>
            <p className='m-0'>Are you sure, deleting this item? Once you delete it won't be able to view again</p>
        </Dialog>
        <div>
            {(blogs?.length>0 && !loading) ? <div>
                <DataTable
                    value={blogs}
                    rows={5}
                    stripedRows
                >
                    <Column
                        header="Image"
                        body={imageTemplate}
                        style={{width: "100px", textAlign: "center"}}
                    />
                    <Column body={titleAuthor} header="Title" sortable/>
                    <Column body={categoryTemplate} header="Category" sortable/>
                    <Column body={publishStatus} header="Publish Status" sortable/>
                    <Column
                        header="Actions"
                        body={actionTemplate}
                        style={{width: "140px", textAlign: "center"}}
                    />
                </DataTable>
                <Paginator
                    first={(page - 1) * perPage}
                    rows={perPage}
                    totalRecords={total}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                />
            </div> :
                <EmptyData/>}
        </div>
    </div>

    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">Newsroom</h4>
            <div>
                <Dropdown value={selectedCategory} onChange={(e) => {
                    setSelectedCategory(e.value)
                    setPage(1)
                }} options={blogsCategory}
                          optionLabel="name"
                          placeholder="Select a Category" className="w-full md:w-14rem mr-2"/>
                <Button onClick={() => navigate(`/newsroom/create`)} label="Create New" icon="pi pi-plus" iconPos="right" />
            </div>
        </div>
    )

    return (
        <Card header={header}>
            {loading ? <TableSkeleton/> : dataTable}
        </Card>
    );
};

export default Newsroom;